// Fallback-Sidebar, wenn für den aktuellen Standort keine eigene Datei existiert.
export default [
  {
    name: 'Übersicht',
    icon: 'nc-icon nc-bulb-63',
    path: '/ket/overview'
  },
  {
    name: 'Standort',
    icon: 'nc-icon nc-circle-10',
    children: [
      {
        name: 'Anmerkungen',
        path: '/ht/anmerkungen'
      },
      {
        name: 'Checkliste Tagesverantwort.',
        path: '/checklist/HTStart'
      },
      {
        name: 'Retterstatus',
        path: '/ht/retterstatus'
      },
      {
        name: 'Tagesprotokoll',
        path: '/ht/tagesprotokoll'
      },
      {
        name: 'Kontaktliste',
        path: '/ht/kontaktliste'
      },
      {
        name: 'Abseilgeräte',
        path: '/ht/hubgeraete'
      },
      {
        name: 'Newsletter',
        path: '/ht/newsletter'
      },
      {
        name: 'Betriebsordner',
        path: '/ht/betriebsordner'
      },
      {
        name: 'Projekte',
        path: '/ht/projekte'
      },
      {
        name: 'Aufgaben',
        path: '/ht/tasks'
      },
      {
        name: 'Einweisungen',
        path: '/ht/einweisungen'
      }
    ]
  },
  {
    name: 'Bau',
    icon: 'nc-icon nc-app',
    children: [
      {
        name: 'Mängel',
        path: '/construction/defects'
      },
      {
        name: 'Inspektionen',
        path: '/construction/inspections'
      },
      {
        name: 'Parcours',
        path: '/construction/parcours'
      }
    ]
  },
  {
    name: 'PSA',
    icon: 'nc-icon nc-settings',
    children: [
      {
        name: 'Übersicht',
        path: '/psa/overview'
      },
      {
        name: 'Suche',
        path: '/psa/psasearch'
      }
    ]
  },
  {
    name: 'Parkleitung/Büro',
    icon: 'nc-icon nc-laptop',
    children: [
      {
        name: 'Tagesreport',
        path: '/pl/tagesreport'
      },
      {
        name: 'Unterweisungen',
        path: '/pl/unterweisungen'
      },
      {
        name: 'Mitarbeiter',
        path: '/pl/trainer'
      },
      {
        name: 'Checklisten Büro',
        path: '/checklist/Buero-weekly'
      },
      {
        name: 'Checklisten verwalten',
        path: '/pl/managelists'
      },
      {
        name: 'Benutzer verwalten',
        path: '/pl/users'
      }
    ]
  },
  {
    name: 'Trainer',
    icon: 'nc-icon nc-circle-10',
    children: [
      {
        name: 'Kontaktliste',
        path: '/ht/kontaktliste'
      },
      {
        name: 'Retterstatus',
        path: '/ht/retterstatus'
      },
      {
        name: 'Betriebsordner',
        path: '/ht/betriebsordner'
      },
      {
        name: 'Newsletter',
        path: '/ht/newsletter'
      }
    ]
  }
]
